import {Injectable} from '@angular/core';
import {BaseService} from './base-service';
import {MenuModifierGroup} from '../_models/menu-modifier-group';

@Injectable({
    providedIn: 'root'
})
export class MenuModifierGroupService extends BaseService<MenuModifierGroup> {
    destination = 'menu-modifier-groups';
}
